import { concat, isEmpty, get, cloneDeep } from 'lodash';
import t from './product.type';

const initialState = {
  listofProducts: [],
  factories: [],
  totalcount: 0,
};

const ProductAttributeReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.GET_ALL_PRODUCTS:
      const updatedArry = cloneDeep(setArrayByCase(state.listofProducts, action.payload));
      return {
        ...state,
        listofProducts: updatedArry,
        totalcount: action.payload.totalCount,
      };
    case t.CLEAR_REDUCER:
      return {
        ...state,
        listofProducts: [],
        factories: [],
      };
    case t.GET_ALL_FACTORIES:
      return {
        ...state,
        factories: action.payload,
      };
    case t.UPDATE_TOTAL_COUNT:
      return {
        ...state,
        totalcount: 0,
      };

    default:
      return state;
  }
};

const setArrayByCase = (array, payload) => {
  if ((!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) || get(payload, 'isScrolled')) {
    array = concat(array, payload.data);
    return array;
  }
  if (!isEmpty(get(payload, 'searchText'))) {
    array = payload.data;
    return array;
  }
  return payload.data;
};
export default ProductAttributeReducer;
